<template>
    <div v-show="editShow">
        <div class="container">
            <el-row :gutter="20">
                <div class="clearfix">
                    <div class="crumbs">
                        <i class="el-icon-back"></i>
                        <el-button type="text" @click="goBack()">返回</el-button>
                    </div>
                    <div class="btn-save">
                        <el-button type="primary" @click="saveClick('ruleForm')"
                        >保存
                        </el-button
                        >
                    </div>
                </div>
                <div class="form-box">
                    <el-form
                            :model="ruleForm"
                            :rules="rules"
                            ref="ruleForm"
                            label-width="120px"
                            class="eidt-el-form"
                    >
                        <el-form-item label="姓名" prop="json">
                            <el-input v-model="ruleForm.json"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证" prop="openId">
                            <el-input v-model="ruleForm.openId"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号" prop="phone">
                            <el-input v-model="ruleForm.phone"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </el-row>
        </div>
    </div>
</template>

<script>
    import UploadImg from "../public/UploadImg";
    import checkPhone from "../common/checkPhone";

    export default {
        name: "editIDCard",
        data() {
            return {
                rules: {
                    json: [{required: true, message: "姓名不能为空", trigger: "blur"}],
                    openId: [{required: true, message: "身份证不能为空", trigger: "blur"}],
                    phone: [{required: false, message: "手机号不能为空", trigger: "blur"}],
                },
                ruleForm: {
                    name: "",
                    json: "",
                    openId: "",
                    type: -2
                },
                idcardId: "",
            };
        },
        props: {
            editShow: {
                type: Boolean,
                default: false,
            },
            editData: {
                type: Object,
            },
        },
        created() {
        },
        watch: {
            $route: "getPath",
            editData: function () {
                const item = this.editData;
                console.log(item)
                if (item) {
                    this.ruleForm = this.editData;
                    this.idcardId = item.idcardId;
                }
            },
        },
        methods: {
            saveClick(ruleForm) {
                this.$refs[ruleForm].validate((valid) => {
                    if (valid) {
                        if (this.idcardId == "" || this.idcardId == undefined) {
                            this.$axios.post("/IDCard/", this.ruleForm).then((res) => {
                                if (res.data.hasError == false) {
                                    this.$message.success("保存成功！");
                                    this.goBack();
                                } else {

                                  this.$message.error(res.data.message);                                }
                            });
                        } else {
                            this.$axios
                                .put("/IDCard/" + this.idcardId + "", this.ruleForm)
                                .then((res) => {
                                    if (res.data.hasError == false) {
                                        this.$message.success("编辑成功！");
                                        this.goBack();
                                    } else {

                                      this.$message.error(res.data.message);                                    }
                                });
                        }
                    } else {
                        return false;
                    }
                });
            },
            goBack() {
                this.editData = null;
                this.$emit("backFunStu");
                this.idcardId = "";
                this.$refs.ruleForm.resetFields();
            },
            getUploadImg(imgSrc) {
                this.ruleForm.avatar = imgSrc;
            },
        },
        components: {
            UploadImg,
        },
    };
</script>